import { render, staticRenderFns } from "./LandingPagePreferenceComponent.vue?vue&type=template&id=22b8a66c&"
import script from "./LandingPagePreferenceComponent.vue?vue&type=script&lang=js&"
export * from "./LandingPagePreferenceComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports